<template>
  <div>
    <h5 class="text-center info-text">Elija el Campo para el cual desea crear el Lote y pulse en SIGUIENTE</h5>

    <div class="row justify-content-center mt-5">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label w-100">
            <span>Seleccione Campo</span>

            <button class="btn btn-link btn-sm btn-fill btn-wd float-right" @click="newField($event)">
              <i class="fas fa-plus"></i>&nbsp;Agregar Campo
            </button>
          </label>

          <el-select
            v-model="selectedField"
            v-validate="modelValidations.field"
            autocomplete="off"
            filterable
            name="field"
            placeholder="Seleccione Campo (*)"
            @input="updateField"
          >
            <el-option v-for="option in fieldsOptions" :key="option.value" :label="option.label" :value="option.value">
            </el-option>
          </el-select>
          <small v-show="field.invalid" class="text-danger">
            {{ getError('field') }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option } from 'element-ui';
import swal from 'sweetalert2';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    selected: {
      type: [Number, String],
      default: null,
    },

    producer: {
      type: [Object, Number, String],
      default: null,
    },
  },

  data() {
    return {
      selectedField: null,
      fields: [],
      modelValidations: {
        field: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['field']),
    fieldsOptions() {
      return this.$selectOptions(this.fields, { sort: true });
    },
  },

  watch: {
    producer() {
      this.selectedField = null;
      this.$validator.reset();
      this.fetchFields();
    },
  },

  created() {
    if (this.selected) {
      this.selectedField = this.selected;
    }
  },

  mounted() {
    if (this.producer) {
      this.fetchFields();
    }
  },

  methods: {
    updateField() {
      const plots = this.fields.find((field) => field.id === this.selectedField).plots;
      this.$emit('updatePlots', plots);
    },

    fetchFields() {
      const producer = typeof this.producer === 'object' ? this.producer.id : this.producer;
      this.$services
        .resource('fields')
        .get({ 'filter[producer]': producer, include: ['city.province', 'plots'] })
        .then((res) => res.data.data)
        .then((data) => {
          if (data.fields.length === 0) {
            throw new Error('the producer has no fields');
          }
          this.fields = data.fields;
        })
        .catch((e) => {
          swal({
            title: `No existen campos para el productor seleccionado!`,
            text: `Por favor, agregue un nuevo campo si es necesario ...`,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-warning',
            type: 'warning',
          }).then(() => this.newField());
        });
    },

    newField(e) {
      this.$emit('newField', e);
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll();
    },

    getSelected() {
      return this.fields.find((f) => this.selectedField === f.id);
    },
  },
};
</script>
